<div class="page-content page-fill">
  <div class="grid-fill">
    <dx-data-grid
      #peopleGrid
      keyExpr="id"
      [dataSource]="people"
      [columnAutoWidth]="false"
      [wordWrapEnabled]="true"
      (onToolbarPreparing)="onToolbarPreparing($event)"
      (onCellDblClick)="rowDoubleClick($event)"
      >
      <dxi-column dataField="firstName" width="120" cellTemplate="personLinkTemplate"></dxi-column>
      <dxi-column dataField="lastName" width="120" cellTemplate="personLinkTemplate" [sortIndex]="1" [sortOrder]="'asc'"></dxi-column>
      <dxi-column dataField="displayAddress" width="250" caption="Address" width="300"></dxi-column>
      <dxi-column dataField="family.name" width="200" caption="Family" width="300" cellTemplate="familyLinkTemplate"></dxi-column>
      <dxi-column dataField="cellPhone" width="150"></dxi-column>
      <dxi-column dataField="email" width="200"></dxi-column>
      <dxi-column dataField="birthDateLocal" caption="Birthday" width="100"></dxi-column>
      <dxi-column dataField="age" width="80"></dxi-column>
      <dxi-column dataField="includeInDirectory" width="80"></dxi-column>
      <dxi-column dataField="includeForGiving" width="80"></dxi-column>
      <dxi-column dataField="envelopeNumber" [visible]="canSeeBudgetBox" width="80"></dxi-column>
      <dxi-column dataField="preferredName" width="80"></dxi-column>

      <div *dxTemplate="let cell of 'personLinkTemplate'">
        @if (peopleAdmin) {
          <a [routerLink]="['/people/' + cell.data.id]" (click)="setFocusedRowKey(cell.data.id)">
            {{ cell.text || '(blank)' }}
          </a>
        }
        @if (!peopleAdmin) {
          <div>
            {{ cell.text || '(blank)' }}
          </div>
        }
      </div>
      <div *dxTemplate="let cell of 'familyLinkTemplate'">
        @if (peopleAdmin && cell.data.familyId) {
          <a [routerLink]="['/people/families/' + cell.data.familyId]" (click)="setFocusedRowKey(cell.data.id)">
            {{ cell.text || '(blank)' }}
          </a>
        }
        @if (!peopleAdmin && cell.data.familyId) {
          <div>
            {{ cell.text || '(blank)' }}
          </div>
        }
        @if (!peopleAdmin && !cell.data.familyId) {
          <div>(no family assigned)</div>
        }
      </div>

      <dxo-filter-row [visible]="true"></dxo-filter-row>
      <dxo-filter-panel [visible]="true"></dxo-filter-panel>
      <dxo-state-storing [enabled]="true" type="sessionStorage" storageKey="peopleGrid"></dxo-state-storing>
      <dxo-search-panel [visible]="true"></dxo-search-panel>
      <dxo-export [enabled]="true" [allowExportSelectedData]="true" [fileName]="'people'"></dxo-export>
      <dxo-selection [mode]="'multiple'"></dxo-selection>

      <div *dxTemplate="let data of 'toolbarButtons'" class="d-flex align-items-center">
        @if (peopleAdmin) {
          <dx-button text="Open" type="default" (onClick)="open(peopleGrid.focusedRowKey)"></dx-button>
        }
        @if (peopleAdmin) {
          <dx-button text="Add" type="normal" (onClick)="open()"></dx-button>
        }
        @if (peopleAdmin) {
          <dx-button text="Add Family" type="normal" (onClick)="add('family')"></dx-button>
        }
        @if (auth.currentUser?.userName === 'mreimink' && false) {
          <button class="btn btn-sm btn-primary ms-2 me-2"  (click)="printPictureDirectory()">Picture Directory</button>
        }
        <dx-select-box
          [(value)]="selectedView"
          [items]="['Directory', 'All']"
          [searchEnabled]="false"
          [showClearButton]="false"
          (valueChange)="selectedViewChanged()"
          class="ms-3"
        ></dx-select-box>
      </div>
      <div *dxTemplate="let data of 'toolbarText'">
        @if (people && appInfo.graafschap) {
          <span class="ms-3"
            ><strong>{{ peopleGrid.instance.totalCount() + ' items' }}</strong></span
            >
          }
        </div>
      </dx-data-grid>
    </div>
  </div>
